"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabError = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var TabError;
(function (TabError) {
    TabError["HistoryDbNotFound"] = "Unavailable";
    TabError["HistoryDbQueryUnsuccessful"] = "Unavailable";
    TabError["MultipleTabTitles"] = "Unavailable";
    TabError["NoDataExpected"] = "NoDataFound";
    TabError["TabTitleNotAvailableToQueryDb"] = "Unavailable";
    TabError["UnsupportedApplication"] = "UnsupportedApplication";
    TabError["UserAddedProcess"] = "CustomApplication";
    TabError["TabTitleSuccess"] = "Unavailable";
    // MacOS
    TabError["ApplicationNotRunning"] = "Unavailable";
    TabError["ApplicationPendingUpgrade"] = "Unavailable - Browser or app may require a restart due to a pending upgrade";
    TabError["BrowserScriptRunnerNotFound"] = "Unavailable";
    TabError["BrowserScriptTimeout"] = "Unavailable";
    TabError["CouldNotGetApplication"] = "Unavailable";
    TabError["CouldNotRetrieveActiveTab"] = "Unavailable";
    TabError["CouldNotRetrieveCurrentWindow"] = "Unavailable";
    TabError["DoesNotRespondToSelector"] = "Unavailable";
    TabError["NilBrowserScript"] = "Unavailable";
    TabError["PermissionNotSet"] = "PermissionsNotSet";
    TabError["UnableToFindCurrentTab"] = "Unavailable";
    TabError["UnexpectedError"] = "Unavailable";
    // Windows
    TabError["InvalidChannelName"] = "Unavailable";
    TabError["InvalidCommandId"] = "Unavailable";
    TabError["NoEnvCreated"] = "Unavailable";
    TabError["NoLoggedInUser"] = "Unavailable";
    TabError["PipeNotAvailable"] = "Unavailable";
    TabError["ProcCreateFailure"] = "Unavailable";
    TabError["TabTitleBadVersion"] = "Unavailable";
    TabError["TabTitleCommandId"] = "Unavailable";
    TabError["TabTitleConnectPipeFailed"] = "Unavailable";
    TabError["TabTitleDeserializeFailure"] = "Unavailable";
    TabError["TabTitleIncorrectMessageType"] = "Unavailable";
    TabError["TabTitleMainWindowsNotFound"] = "Unavailable";
    TabError["TabTitleNoAppFrameHost"] = "Unavailable";
    TabError["TabTitleNoTitleFound"] = "Unavailable";
    TabError["TabTitlePidNotInTable"] = "Unavailable";
})(TabError = exports.TabError || (exports.TabError = {}));
